import { PublicationCreatorOrgunit } from './publication-creator-orgunit';
import { Person } from 'app/fs/res/common/model/person/person';

export class PublicationCreator {
    id: number;
    creatorname: string;
    firstname: string;
    nameprefix?: string;
    namesuffix?: string;
    person: Person;
    sortorder: number;
    lockVersion: number;
    hasVisibleAffiliations: boolean;
    orcid?: string[];
    creatorOrganizations: PublicationCreatorOrgunit[]; // internal organization
    isPublicationContact?: boolean;
    email?: string;

    constructor( id?: number, creatorname?: string, firstname?: string,
        person?: Person, creatorOrganizations?: PublicationCreatorOrgunit[],
        sortorder?: number ) {
        this.id = id;
        this.creatorname = creatorname;
        this.firstname = firstname;
        this.person = person;
        this.creatorOrganizations = creatorOrganizations;
        this.sortorder = sortorder;
    }
}
